<script setup lang="ts">
import { ref } from "vue"
import { VueFinalModal } from "vue-final-modal"

const props = withDefaults(
  defineProps<{
    title?: string
    clickToClose?: boolean
  }>(),
  {
    clickToClose: true,
  },
)

const toggleState = ref(false)

const toggle = () => {
  toggleState.value = !toggleState.value
}

const close = () => {
  toggleState.value = false
}
</script>

<template>
  <slot :toggle="toggle"></slot>
  <VueFinalModal
    v-model="toggleState"
    class="modal-class"
    content-class="modal-content"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    :clickToClose="clickToClose"
  >
    <slot name="modal" :close="close" />
  </VueFinalModal>
</template>

<style>
.modal-class {
  @apply flex flex-col items-center justify-center;
}

.modal-content {
  @apply mx-auto min-h-[500px] max-h-[90vh] overflow-y-auto max-w-2xl;@apply mx-auto max-w-2xl;
}

.modal-content > * + * {
  margin: 0.5rem 0;
}
</style>
